export default __webpack_public_path__ + "static/media/logo.29f10f72.png";